import "./index.css";
import { Completion } from "./components/Completion";
import { FeedbackCard } from "./components/FeedbackCard";
import { QuestionCard } from "./components/QuestionCard";
import { ReviewHeader } from "./components/ReviewHeader";
import { useReviewSession } from "./lib/useReviewSession";

export function App() {
	const review = useReviewSession();
	const { current, session, questions, currentIndex, attempt } = review;

	if (!current || session.currentIndex >= questions.length) {
		return (
			<Completion
				correctCount={review.correctCount}
				reviewCount={review.reviewCount}
				attempts={session.attempts}
				questions={questions}
				onReviewAll={review.reviewAll}
				onReviewMissed={review.reviewMissed}
			/>
		);
	}

	return (
		<main className="review-shell">
			<ReviewHeader
				current={current}
				currentIndex={currentIndex}
				questions={questions}
				completed={review.completed}
				correctCount={review.correctCount}
				reviewCount={review.reviewCount}
				attempts={session.attempts}
				chapterNumbers={review.chapterNumbers}
				currentChapterNumber={review.currentChapterNumber}
				onResetProgress={review.resetProgress}
			/>
			<section id="review" className="review-content">
				<div className="intro-message">
					<span className="assistant-avatar" aria-hidden="true">
						✦
					</span>
					<div>
						<p className="eyebrow">GUIDED REVIEW</p>
						<p>
							Let’s review Unit 3: HCI Methods. I’ll ask one question at a time.
							Answer from memory, then we can unpack anything you want to
							revisit.
						</p>
					</div>
				</div>
				<QuestionCard
					key={current.id}
					current={current}
					attempt={attempt}
					selectedAnswer={review.selectedAnswer}
					shortAnswer={review.shortAnswer}
					isGrading={review.isGrading}
					gradingError={review.gradingError}
					canSubmit={review.canSubmit}
					currentIndex={currentIndex}
					questionCount={questions.length}
					onSelectAnswer={review.setSelectedAnswer}
					onShortAnswerChange={review.setShortAnswer}
					onSubmit={review.submitAnswer}
				/>
				{attempt && (
					<FeedbackCard
						current={current}
						attempt={attempt}
						questionMessages={review.questionMessages}
						explanation={review.explanation}
						chatInput={review.chatInput}
						isExplaining={review.isExplaining}
						isChatting={review.isChatting}
						chatError={review.chatError}
						currentIndex={currentIndex}
						questionCount={questions.length}
						onExplain={review.requestExplanation}
						onNext={review.nextQuestion}
						onChatInputChange={review.setChatInput}
						onSendMessage={review.sendMessage}
					/>
				)}
			</section>
		</main>
	);
}

export default App;
